module.exports = __webpack_public_path__ + "static/data-and-analytics-services-banner-overlay-1ea77dbc9ecce959cb21684c88450595.jpg";